import { render, staticRenderFns } from "./inputnumber.vue?vue&type=template&id=2cf11bc2&"
import script from "./inputnumber.js?vue&type=script&lang=js&"
export * from "./inputnumber.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\e-trailor\\Bont\\Frontend\\BontScheduler.Portal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cf11bc2')) {
      api.createRecord('2cf11bc2', component.options)
    } else {
      api.reload('2cf11bc2', component.options)
    }
    module.hot.accept("./inputnumber.vue?vue&type=template&id=2cf11bc2&", function () {
      api.rerender('2cf11bc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/components/common/inputs/inputnumber.vue"
export default component.exports